import React, { useState } from "react";
import { Button, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateDisplayNoShowModal } from "../../../reducer/bookingReducer";
import { CircularProgress } from "@mui/material";
import useAllBookingFunction from "../../../hooks/bookingCustomHook/useAllBookingFunction";

const ConfirmationModalNoShow = () => {
  const { displayNoShowModal } = useSelector((store) => store.booking);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const { handleBookingToBeMarkedNoShow } = useAllBookingFunction(setLoading);
  const handleClose = () => {
    dispatch(updateDisplayNoShowModal());
  };

  return (
    <Modal
      open={displayNoShowModal}
      centered
      title=""
      mask={true}
      styles={{ mask: { backdropFilter: "blur(2px)" } }}
      width={"auto"}
      onCancel={handleClose}
      footer={
        <div className="w-[100%] flex gap-2 justify-center mt-5 font-body">
          <Button
            className="text-[16px] w-[11rem] h-[3rem]
            border-primary text-primary rounded-[0.5rem] font-[500] "
            onClick={handleClose}
          >
            NO
          </Button>

          <Button
            className="text-fg-inverse text-[16px] rounded-xl  bg-danger 
            w-[11rem] h-[3rem] font-[600]"
            onClick={loading ? undefined : handleBookingToBeMarkedNoShow}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <div>YES</div>
            )}
          </Button>
        </div>
      }
    >
      <div className="font-body text-[1.125rem] font-[600] mb-2 text-fg-secondary">
        Booking No Show?
      </div>
      <div className="text-fg-muted font-body text-[0.875remrem] font-[400]">
        By Clicking Yes your booking will be listed as No-show.
      </div>
    </Modal>
  );
};

export default ConfirmationModalNoShow;
